import React, {useEffect, useState} from 'react'
import { Combobox, ComboboxInput, ComboboxButton, ComboboxOption, ComboboxOptions, Field, Label } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

export default function FormInputSelectAsync({ widthClass, className, selected, setSelected, options, updateOptions, label, renderOption, renderDisplay }) {
  const [ query, setQuery ] = useState('');

  function handleChange(e) {
    e.preventDefault()
    setQuery(e.target.value)
  }

  useEffect(() => {
    updateOptions(query);
  }, [query])

  return (
    <Field>
      { label && (<Label className="block text-sm font-normal text-gray-700 mb-1">{label}</Label>) }
      <Combobox value={selected} onChange={setSelected} onClose={() => setQuery('')}>
        <div className="relative">
          <ComboboxInput
            displayValue={(option) => {
              return renderDisplay(option)
            }}
            onChange={handleChange}
            className={className ? className : `
              rounded-md bg-white/5 py-1.5 pr-8 pl-3 text-sm/6
              border-gray-300 focus:border-teal-500 focus:ring-teal-500
              focus:not-data-focus:outline-none
            `}
          />
          <ComboboxButton className="group absolute inset-y-0 right-0 px-2.5">
            <ChevronDownIcon className="size-4 fill-gray-600 group-data-hover:fill-white" />
          </ComboboxButton>
        </div>
        <ComboboxOptions
          anchor="bottom"
          className="
            z-50 mt-3 rounded-sm bg-white border-gray-400 shadow-md border-white/5 [--anchor-gap:--spacing(1)] empty:invisible
            transition duration-100 ease-in data-leave:data-closed:opacity-0
          "
        >
          {options.map((option) => (
            <ComboboxOption
              key={option.id}
              value={option}
              className="
                data-focus:bg-teal-100 cursor-pointer
                group flex items-center gap-2 px-4 py-2 select-none data-focus:bg-white/10
                hover:bg-stone-100
              "
            >
              { renderOption ? renderOption(option) : option.name }
            </ComboboxOption>
          ))}
        </ComboboxOptions>
      </Combobox>
    </Field>
  )
}
